import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { HubConfigRolesBulkAddDrawerModule } from './hub-config-roles-bulk-add-drawer/hub-config-roles-bulk-add-drawer.module';
import { ChipModule } from '@libs/src/chip/chip.module';
import { DialogConfirmPromptModule } from '@libs/src/dialog-confirm-prompt/dialog-confirm-prompt.module';
import { ToastModule } from '@libs/src/toast/toast.module';
import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';
import { TtcNzTableModule } from '@libs/src/ttc-nz-table/ttc-nz-table.module';
import { BestPracticesCardModule } from '@main-client/src/app/best-practices-card/best-practices-card.module';
import { HubConfigRolesBulkDeleteDrawerModule } from '@main-client/src/app/hub-configuration/hub-config-roles/hub-config-roles-bulk-delete-drawer/hub-config-roles-bulk-delete-drawer.module';
import { HubConfigRolesDrawerModule } from '@main-client/src/app/hub-configuration/hub-config-roles/hub-config-roles-drawer/hub-config-roles-drawer.module';
import { HubConfigRolesSettingsModule } from '@main-client/src/app/hub-configuration/hub-config-roles/hub-config-roles-settings/hub-config-roles-settings.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';
import { UploadCsvListDrawerModule } from '@main-client/src/app/upload-csv-list-drawer/upload-csv-list-drawer.module';

import { GroupsBackend } from '@libs/src/groups/groups.backend';
import { ReportingBackend } from '@libs/src/reporting/reporting.backend';

import { HubConfigRolesComponent } from './hub-config-roles.component';

@NgModule({
  declarations: [HubConfigRolesComponent],
  exports: [HubConfigRolesComponent],
  imports: [
    BestPracticesCardModule,
    ChipModule,
    CommonModule,
    DialogConfirmPromptModule,
    DragDropModule,
    FlexLayoutModule,
    HubConfigRolesBulkAddDrawerModule,
    HubConfigRolesBulkDeleteDrawerModule,
    HubConfigRolesDrawerModule,
    HubConfigRolesSettingsModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    NzIconModule,
    NzInputModule,
    NzToolTipModule,
    ReactiveFormsModule,
    ToastModule,
    TranslationLookupModule,
    TtcNzTableModule,
    TtcMatInputModule,
    UploadCsvListDrawerModule,
  ],
  providers: [GroupsBackend, ReportingBackend],
})
export class HubConfigRolesModule {}
